// extracted by mini-css-extract-plugin
export default {"root":"YddNve7nc2VGZ9x9VvkT","card":"lXG4HKE4qTetBY_oHLrX"};